import {Dialog, DialogTitle, makeStyles, Typography} from "@material-ui/core";
import {useTranslate} from "react-admin";
import Form from "./form";
import FiberNew from "@material-ui/icons/FiberNew";
import SettingsIcon from "@material-ui/icons/Settings";

const useStyle = makeStyles(() => ({
    dialogTitle: {
        padding: '22px 26px 8px',
    },
    container: {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        alignItems: 'center',
        columnGap: '10px',
    },
    dialogTitleText: {
        fontWeight: 700,
        fontSize: '1.5rem',
        lineHeight: 1.25,
        letterSpacing: '-0.015em',
        color: '#092b4b',
    }
}))

const DlgForm = (props: { isOpen: boolean, cancel: () => void, action: 'CREATE' | 'EDIT' }) => {
    const t = useTranslate()
    const classes = useStyle()
    return (
        <Dialog open={props.isOpen} onClose={props.cancel} fullWidth maxWidth="sm">
            <DialogTitle disableTypography className={`${classes.dialogTitle} ${classes.container}`}>
                {props.action === 'CREATE' ? <FiberNew color="primary"/> : <SettingsIcon color="primary"/>}
                <Typography color="primary" className={classes.dialogTitleText}>
                    {t(`app.types.${props.action === 'CREATE' ? 'create' : 'edit'}`)}
                </Typography>
            </DialogTitle>
            <Form toggleDlg={props.cancel} action={props.action}/>
        </Dialog>
    )
}

export default DlgForm;
